import { httpServiceClient } from '@/infra/http'
import { makeApiUrl, makeUserAccountProfileUrl } from '@/main/factories/http/api-url-factory'
import { formatCustomDateString } from '@/main/helpers'
import type {
  CareerMentorProfileData,
  CareerMentorUpdatePhoneParams,
  CareerMentorActiveMessageParams
} from './career-mentor-service-types'
import { buildActiveMessageBody } from './career-mentor-service-utils'

export type {
  CareerMentorProfileData,
  CareerMentorUpdatePhoneParams,
  CareerMentorActiveMessageParams,
  CareerMentorTemplateName
} from './career-mentor-service-types'
export { CAREER_MENTOR_MESSAGE_TEMPLATE } from './career-mentor-service-types'

export const createCareerMentorService = (client = httpServiceClient) => ({
  async fetchProfile(): Promise<CareerMentorProfileData | undefined> {
    const response = await client<CareerMentorProfileData>({
      method: 'get',
      url: makeUserAccountProfileUrl()
    })
    return response?.body?.data ?? undefined
  },

  async updatePhone({
    phone,
    personalEmail,
    birthDate
  }: CareerMentorUpdatePhoneParams): Promise<void> {
    await client({
      method: 'patch',
      url: makeApiUrl('/v2/user/account/personal-data'),
      body: {
        phone,
        personalEmail,
        birthdate: birthDate ? formatCustomDateString(birthDate, 'yyyy-mm-dd') : undefined
      }
    })
  },

  async sendActiveMessage(params: CareerMentorActiveMessageParams): Promise<void> {
    await client({
      method: 'post',
      url: makeApiUrl('/v2/career-mentor/active-message'),
      body: buildActiveMessageBody(params)
    })
  }
})

export const careerMentorService = createCareerMentorService()
